export default __webpack_public_path__ + "static/hhc-bears-rings-5ddbe737ab555c801a34ee0fea76108f.png";